///////////////////////////////////////////////////

import { tabsApiConnector } from 'apiConnector/tabs/tabs';
import { ofType } from 'redux-observable';
import { EMPTY } from 'rxjs';
import { catchError, filter, map, mergeMap, takeUntil } from 'rxjs/operators';
import { secondaryMarketCpOrderTabContentPersisted } from 'state/secondaryMarket/cpOrder';
import type { EpicWithThunk } from 'state/state.common';

import { getTabRemoved$ } from '../utils';

export function persistCpOrderTabContentEpic(): EpicWithThunk {
  return (actions$, _, { httpClient }) => {
    const { updateTabContent } = tabsApiConnector(httpClient, 'secondaryMarketPostEvents');
    return actions$.pipe(
      ofType('SECONDARY_MARKET_CP_ORDER_TAB_CONTENT_PERSIST_REQUESTED'),
      filter(({ workspace }) => workspace === 'secondaryMarketPostEvents'),
      mergeMap(({ tabId, tabContent }) => {
        return updateTabContent(tabId, tabContent).pipe(
          takeUntil(getTabRemoved$(actions$, tabId)),
          map(() => secondaryMarketCpOrderTabContentPersisted(tabId, 'secondaryMarketPostEvents', tabContent)),
          catchError(() => EMPTY),
        );
      }),
    );
  };
}
